import { render, staticRenderFns } from "./ConfirmAccountUpdate.vue?vue&type=template&id=04b13881"
import script from "./ConfirmAccountUpdate.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports